import {
  getNotificationTypeConfig,
  getMessageNotificationContent,
  getTaskDetails,
  formatNotificationTime,
} from './notificationUtils';

function UserPlusIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <line x1="19" y1="8" x2="19" y2="14" />
      <line x1="22" y1="11" x2="16" y2="11" />
    </svg>
  );
}

function CheckSquareIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="9 11 12 14 22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  );
}

function BellIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </svg>
  );
}

function SettingsGearIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

function WhatsAppIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </svg>
  );
}

function PaperAirplaneIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="m22 2-7 20-4-9-9-4Z" />
      <path d="M22 2 11 13" />
    </svg>
  );
}

function renderTypeIcon(iconType) {
  switch (iconType) {
    case 'whatsapp':
    case 'instagram':
    case 'message':
    case 'chat':
      return <WhatsAppIcon className="w-5 h-5" />;
    case 'integration':
    case 'workspace':
    case 'unhealthy':
    case 'disconnected':
    case 'connected':
    case 'reconnected':
      return <SettingsGearIcon className="w-5 h-5" />;
    case 'lead':
    case 'stage':
    case 'contact':
    case 'client':
      return <UserPlusIcon className="w-5 h-5" />;
    case 'task':
    case 'reminder':
      return <CheckSquareIcon className="w-5 h-5" />;
    case 'campaign':
      return <PaperAirplaneIcon className="w-5 h-5" />;
    case 'bell':
    default:
      return <BellIcon className="w-5 h-5" />;
  }
}

export function NotificationItem({
  notification,
  isUnread,
  section = 'today',
  onSelect,
}) {
  const typeConfig = getNotificationTypeConfig(notification);
  const content = getMessageNotificationContent(notification);
  const taskDetails = getTaskDetails(notification);
  const timeInfo = formatNotificationTime(notification?.created_at, section);

  const titleText =
    content?.heading || content?.title || notification?.title || 'Notification';

  const subtextContent =
    content?.preview || content?.subtext || notification?.message || '';

  const displayTime = timeInfo?.relative || timeInfo?.display || '';
  const tooltipTime = timeInfo?.tooltip || timeInfo?.full || '';
  const channelBadge = content?.channelLabel || content?.channelBadge || null;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect?.(notification)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onSelect?.(notification);
        }
      }}
      data-unread={isUnread ? 'true' : 'false'}
      className={`notification-card w-full text-left bg-white rounded-2xl border border-[#EBEBEB] p-3.5 sm:p-4 flex ${
        taskDetails?.progress ? 'items-start' : 'items-center'
      } justify-between gap-4 transition-all duration-150 hover:border-slate-300 hover:shadow-xs cursor-pointer ${
        isUnread ? 'border-primary/40' : ''
      }`}
    >
      <div
        className={`flex ${
          taskDetails?.progress ? 'items-start pt-0.5' : 'items-center'
        } gap-3.5 min-w-0 flex-1`}
      >
        {/* Type Avatar */}
        <div
          className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 ${
            typeConfig?.bgClass || 'bg-slate-100 text-slate-600'
          }`}
        >
          {renderTypeIcon(typeConfig?.iconType)}
        </div>

        {/* Text Block */}
        <div className="flex flex-col min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <span
              className={`text-sm tracking-tight truncate ${
                isUnread
                  ? 'font-bold text-slate-900'
                  : 'font-bold text-slate-800'
              }`}
            >
              {titleText}
            </span>
            {channelBadge && (
              <span className="text-[10px] font-bold px-2 py-0.5 rounded border uppercase tracking-wider bg-[#EBFBF0] text-[#128C7E] border-[#A7E8BD]">
                {channelBadge}
              </span>
            )}
          </div>

          {subtextContent && (
            <p className="text-xs text-slate-500 mt-1 leading-snug line-clamp-2 break-words">
              {subtextContent}
            </p>
          )}

          {/* Task / Campaign Progress Bar */}
          {/* {taskDetails?.progress && (
            <div className="mt-3 w-full">
              <div className="flex justify-between items-center text-xs text-slate-500 mb-1.5 font-medium">
                <span className="flex items-center gap-1.5">
                  <span className="font-medium text-slate-600">Progress</span>
                  {taskDetails.statusLabel && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 font-semibold uppercase tracking-wider">
                      {taskDetails.statusLabel}
                    </span>
                  )}
                </span>
                <span className="font-semibold text-slate-700">
                  {taskDetails.progress.text} ({taskDetails.progress.percentage}%)
                </span>
              </div>
              <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden border border-slate-200/70">
                <div
                  className={`h-full rounded-full transition-all duration-300 ${
                    taskDetails.progress.percentage === 100
                      ? 'bg-[#4BB543]'
                      : 'bg-primary'
                  }`}
                  style={{ width: `${taskDetails.progress.percentage}%` }}
                />
              </div>
            </div>
          )} */}
        </div>
      </div>

      {/* Timestamp on right */}
      <div className="shrink-0 self-start pt-0.5">
        <span
          title={tooltipTime}
          className="text-xs text-slate-400 font-medium whitespace-nowrap"
        >
          {displayTime}
        </span>
      </div>
    </div>
  );
}
